import request from '@/utils/request'

export function fetchChannels() {
  return request.get('/api/channels')
}

export function createChannel(data) {
  return request.post('/api/channels', data)
}

export function updateChannel(id, data) {
  return request.put(`/api/channels/${id}`, data)
}

export function deleteChannel(id) {
  return request.delete(`/api/channels/${id}`)
}

export function testChannel(id, data = {}) {
  return request.post(`/api/channels/${id}/test`, data)
}
